import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import clsx from 'clsx';
import axios from 'axios';

import serverURI from 'config/URI';

import { 
  Button, 
  Dialog, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  Card,
  CardHeader,
  // CardActions,
  CardContent,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { toast } from 'react-toastify';

//import { areas, groups, statusContracts, typesCompany } from 'common/datas';
import { IsNoU } from 'common/utils';

//import { StatusAdvertise, StatusBullet } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '120px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '260px',
    //height: '40px',
  },

  // gridList: {
  //   width: 500,
  //   height: 450,
  // },
  // icon: {
  //   color: 'rgba(255, 255, 255, 0.54)',
  // },

  option: {
    fontSize: 15,
    '& > span': {
      marginRight: 10,
      fontSize: 18,
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RegisterCar = props => {

  const {
    className,
    openDialog,
    modeRegisterDialog,
    onClickCloseDialog,
    onClickSaveDialog,

    companies,
    distributors,
    editCar,
  } = props;

  const classes = useStyles();

  const [carNumber, setCarNumber] = useState('');
  const [selectedCompany, setSelectedCompany] = useState('');
  const [deviceSerialNo, setDeviceSerialNo] = useState('');
  const [device_installed_at, setDeviceInstalledAt] = useState(undefined);
  const [carType, setCarType] = useState('');
  const [carYear, setCarYear] = useState('');
  const [selectedDistributor, setSelectedDistributor] = useState('');
  
  // const handleChangeCompany = event => {
  //   setSelectedCompany(event.target.value);
  // };

  const getCheckedCar = (car_number, company) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/company/car/check`,
      data: {
        car_number: car_number, company: company,
      }
    });
  }


  useEffect(() => {
    //console.log("componentDidMount");

    if (!IsNoU(editCar))
    {
      setCarNumber(editCar.number);
      setSelectedCompany(editCar.company);
      if (!IsNoU(editCar.device_serial_no) && editCar.device_serial_no.length > 0) {
        setDeviceSerialNo(editCar.device_serial_no);
      }
      else {
        setDeviceSerialNo('');
      }
      if (!IsNoU(editCar.device_installed_at) && editCar.device_installed_at.length > 0) {
        setDeviceInstalledAt(editCar.device_installed_at);
      }
      else {
        setDeviceInstalledAt(undefined);
      }
      setCarType(editCar.type);
      setCarYear(editCar.year);
    }
    else {
      setCarNumber('');
      setSelectedCompany('');
      setDeviceSerialNo('');
      setDeviceInstalledAt(undefined);
      setCarType('');
      setCarYear('');
    }

  }, [editCar]); // empty-array means don't watch for any updates

  // useEffect(() => {
  //   console.log("componentDidMount");

  //   if (!IsNoU(companies))
  //   {
  //     if (companies.length > 0)
  //       setSelectedCompany(companies[0]);
  //     else
  //       setSelectedCompany('');
  //   }

  // }, [companies]); // empty-array means don't watch for any updates

  return (
    <div>
      <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              차량
            </Typography>
            <Button autoFocus color="inherit" onClick={async () => {

                if (IsNoU(carNumber) || carNumber.length <= 0) {
                  toast("차량번호를 입력하세요.");
                  return ;
                }

                if (IsNoU(selectedCompany) || selectedCompany.length <= 0) {
                  toast("택시회사명을 입력하세요.");
                  return ;
                }

                if (IsNoU(editCar)) {
                  const res = await getCheckedCar(carNumber, selectedCompany);
                  const checked_car = res.data.checked_car;
                  if (!checked_car) {
                    toast(carNumber+" 번호가 존재합니다..");
                    return ;
                  }
                }

                const newCar = {
                  number: carNumber,
                  company: selectedCompany,
                  device_serial_no: deviceSerialNo,
                  device_installed_at: device_installed_at,
                  type: carType,
                  year: carYear,
                  distributor: selectedDistributor,
                };

                if (!IsNoU(editCar))
                  newCar.id = editCar.id;

                onClickSaveDialog(newCar);
              }}>
              저장
            </Button>
          </Toolbar>
        </AppBar>

        <List>
          <ListItem>
            <Card
              className={clsx(classes.card_root, className)}
            >
              <CardHeader
                className={classes.card_header}
                title={modeRegisterDialog ? '차량 등록' : '차량 수정'}
                subheader='*표시는 필수 항목'
              />
              <CardContent className={classes.content}>
                <List>
                  <ListItem className={classes.listitem_align}>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-car-number"
                      label="차량번호"
                      placeholder="차량번호를 입력하세요..."
                      required
                      //variant="outlined" 
                      value={carNumber}
                      onChange={event=> setCarNumber(event.target.value)}
                      margin="dense"/>

                    <Box p={2} />

                    <Autocomplete
                      id="reg-car-company-name-auto"
                      options={companies.map(company => company.name)}
                      // getOptionLabel={
                      //   option => option.name
                      //   //option => option
                      // }
                      style={{ width: 260 }}
                      value={selectedCompany}
                      onChange={(event, newValue) => {
                        //console.log(newValue);
                        setSelectedCompany(newValue);
                      }}
                      // onChange={event=> setSelectedCompany(event.target.value)}
                      renderInput={params => (
                        <TextField {...params} 
                          //variant="outlined" 
                          label="택시회사 명"
                          required
                          //placeholder="차량번호를 입력하세요..."
                          fullWidth 
                          margin="dense" />
                      )}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-car-device-serial"
                      label="디바이스 SN"
                      //placeholder="디바이스 SN를 입력하세요..."
                      //variant="outlined" 
                      value={deviceSerialNo}
                      //onChange={}
                      disabled
                      margin="dense"/>

                    <Box p={2} />

                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-car-device-installed"
                      label="디바이스 장착일"
                      //placeholder="디바이스 SN를 입력하세요..."
                      //variant="outlined" 
                      value={device_installed_at === undefined ? '' : moment(device_installed_at).format('YYYY-MM-DD')}
                      //onChange={}
                      disabled
                      margin="dense"/>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-car-type"
                      label="차종"
                      //placeholder="디바이스 SN를 입력하세요..."
                      //variant="outlined" 
                      value={carType}
                      onChange={event=> setCarType(event.target.value)}
                      margin="dense"/>

                    <Box p={2} />

                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-car-year"
                      label="연식"
                      //placeholder="디바이스 SN를 입력하세요..."
                      //variant="outlined" 
                      value={carYear}
                      onChange={event=> setCarYear(event.target.value)}
                      margin="dense"/>
                  </ListItem>
                  <Divider />
                  <ListItem>
                  <Autocomplete
                      id="reg-car-distributor-name-auto"
                      options={distributors.map(distributor => distributor.name)}
                      // getOptionLabel={
                      //   option => option.name
                      //   //option => option
                      // }
                      style={{ width: 260 }}
                      value={selectedDistributor}
                      onChange={(event, newValue) => {
                        //console.log(newValue);
                        setSelectedDistributor(newValue);
                      }}
                      // onChange={event=> setSelectedCompany(event.target.value)}
                      renderInput={params => (
                        <TextField {...params} 
                          //variant="outlined" 
                          label="대리점 명"
                          //required
                          //placeholder="차량번호를 입력하세요..."
                          fullWidth 
                          margin="dense" />
                      )}
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </ListItem>
          
          
         
        </List>
      </Dialog>
    </div>
  );
}

RegisterCar.propTypes = {
  className: PropTypes.string,
  companies: PropTypes.array.isRequired,
  distributors: PropTypes.array.isRequired,
};

RegisterCar.defaultProps = {
  companies: [],
  distributors: [],
};


export default RegisterCar;
